import { State } from './state';
import { ActionTypes, AUTHENTICATE, LOGOUT, SET_PROFILE } from './types';

export default (state: State, action: ActionTypes): State => {
  switch (action.type) {
    case AUTHENTICATE:
      localStorage.setItem('accessToken', action.payload.accessToken ? action.payload.accessToken : '');
      localStorage.setItem('refreshToken', action.payload.refreshToken ? action.payload.refreshToken : '');
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT:
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('profile');
      localStorage.removeItem('next_maintenance_at');
      localStorage.removeItem('instance_id');
      sessionStorage.clear();
      return {
        accessToken: undefined,
        refreshToken: undefined,
        profile: undefined,
      };
    case SET_PROFILE:
      localStorage.setItem('profile', action.payload ? JSON.stringify(action.payload) : '');
      return {
        ...state,
        profile: action.payload,
      };
    default:
      return state;
  }
};
